import type { ApiClient } from './client';

const built = new WeakMap<ApiClient, Map<unknown, unknown>>();

/**
 * A feature module's endpoints, built on first use from the session's client and
 * kept per client. Modules call this from their own lazily loaded code, so their
 * endpoint tables stay out of the initial bundle: createApi carries only what
 * sign-in, the shell and more than one module need.
 */
export function moduleApi<T>(client: ApiClient, factory: (client: ApiClient) => T): T {
  let forClient = built.get(client);
  if (!forClient) {
    forClient = new Map();
    built.set(client, forClient);
  }
  if (!forClient.has(factory)) forClient.set(factory, factory(client));
  return forClient.get(factory) as T;
}
